import React from "react";

type Props = {
  children: React.ReactComponentElement<never> | React.ReactNode;
};
const PublicLayout = ({ children }: Props) => {
  return (<div className="w-full h-screen overflow-y-auto">
    <div>{children}</div>
  </div>);
};

export default PublicLayout;
